import React from "react"
import { FooterType } from "../types"
// Footers are imported statically (not via @loadable/component) so they are
// rendered into the static HTML at build time. Ad platforms verify that the
// footer phone number and disclosures exist in the page source, and lazily
// loaded components are absent from it because the loadable SSR plugin is
// not enabled.
import FooterDefault from "./footers/footer-default"
import FooterDefaultLogo from "./footers/footer-logo"
import FooterUHSM from "./footers/footer-uhsm"
import FooterCalicovered from "./footers/footer-calicovered"
import FooterMediaLanding from "./footers/footer-media-landing"
import FooterEnrollment from "./footers/footer-enrollment"
import FooterTwoSections from "./footers/footer-two-sections-v3"
import FooterModern from "./footers/footer-modern"
import FooterWeshare from "./footers/footer-weshare"
import FooterChm from "./footers/footer-chm"
import FooterMedshare from "./footers/footer-medshare"
type LayoutProps = {
  footer: FooterType
  [key: string]: any
}

const Footer = ({ footer, ...props }: LayoutProps) => {
  switch (footer?.templateId) {
    case `uhsm`:
      return <FooterUHSM footer={footer} {...props} />
    case `calicoverage`:
      return <FooterCalicovered footer={footer} {...props} />
    case `footer-media-landing`:
      return <FooterMediaLanding footer={footer} {...props} />
    case `default-logo`:
      return <FooterDefaultLogo footer={footer} {...props} />
    case `annualopenenrollment-logo`:
      return <FooterEnrollment footer={footer} {...props} />
    case `two-sections-v3`:
      return <FooterTwoSections footer={footer} {...props} />
    case `footer-modern`:
      return <FooterModern footer={footer} {...props} />
    case `weshare`:
      return <FooterWeshare footer={footer} {...props} />
    case `chm`:
      return <FooterChm footer={footer} {...props} />
    case `medshare`:
      return <FooterMedshare footer={footer} {...props} />
    case `empty`: 
      return null;
    default:
      return <FooterDefault footer={footer} {...props} />
  }
}

export default Footer
